export default __webpack_public_path__ + "static/media/landscape2-MASK-wood.0616afc6.png";